<template>
  <Dialog
    title="Image Preview"
    :show-close-button="true"
    :show-save-button="false"
    :show-cancel-button="false"
    :show-footer="true"
    @close-event="handleClose"
    md
  >
    <template #modal-content>
      <div class="px-3 pt-3 d-flex justify-content-center">
        <div
          class="p-2 text-muted flex justify-center gap-2 w-max mx-auto bg-primary-light rounded-lg"
        >
          <MagnifyingGlassPlusIcon class="size-5" />
          Please hover over the images to zoom!
        </div>
      </div>
      <div class="grid grid-cols-2 justify-center gap-1 py-4 px-3">
        <ZoomOnHover
          :image-src="storage_url + '/' + images.frontImage.url"
          :img-zoom="storage_url + '/' + images.frontImage.url"
          :scale="2"
        />
        <ZoomOnHover
          :image-src="storage_url + '/' + images.backImage.url"
          :img-zoom="storage_url + '/' + images.backImage.url"
          :scale="2"
        />
      </div>
    </template>
    <template #footer>
      <div class="px-3 pb-3 d-flex justify-content-center">
        <button class="btn btn-dark text-white" @click="downloadImages(images, order_no)">
          <!-- v-if="!loadingPreviewImages" -->
          Download Preview Images
        </button>
      </div>
    </template>
  </Dialog>
</template>
<script lang="ts" setup>
import Dialog from '@/components/Shared/Dialog.vue';
import { storage_url } from '@/composables';
import { useOrderDetail } from '@/composables/useOrderDetail';
import { ActivityItem, FactoryProduct } from '@/models';
import { MagnifyingGlassPlusIcon } from '@heroicons/vue/24/outline';
import { computed } from 'vue';
import ZoomOnHover from './ZoomOnHover.vue';

interface Props {
  factory_product?: FactoryProduct;
  order_no: string;
  activity_item?: ActivityItem;
}
const props = defineProps<Props>();
const { downloadImages } = useOrderDetail();
const images = computed(() => {
  if (props.factory_product) {
    return {
      frontImage: props.factory_product.front_image,
      backImage: props.factory_product.back_image,
    };
  } else {
    return {
      frontImage: props.activity_item.activity_files[0],
      backImage: props.activity_item.activity_files[1],
    };
  }
});
const emits = defineEmits(['close']);
const handleClose = () => {
  emits('close');
};
</script>
<style lang="scss" scoped></style>
